// any app specific constants that you don't want to keep in config can go here.
export const SYSTEM_ERROR = 'System error. Please try again later!';
export const CTA_YES = 'Yes';
export const CTA_NO = 'No';
export const CTA_CANCEL = 'Cancel';

// socket event
export const MESSAGE = 'message';
export const USER_ONLINE = 'user_online';
export const USER_OFFLINE = 'user_offline';
export const NEW_EMPLOYEE = 'new_employee';
export const NEW_CUSTOMER = 'new_customer';

// roles
export const role = {
    ADMIN: 'ADMIN',
    PILOT: 'PILOT',
    CREW: 'CREW',
    OPERATIONS: 'OPERATIONS'
};

export const allowedRolesCreateQuote = ['ADMIN', 'OPERATIONS'];

// document types
export const documentTypes = {
    PASSPORT: 'PASSPORT',
    VISA: 'VISA',
    ID_CARD: 'ID_CARD',
    DRIVER_LICENSE: 'DRIVER_LICENSE'
};

export const itemType = [
    {
        id: 0,
        code: 'MAIN_DISH'
    },
    {
        text: 1,
        code: 'STARTERS'
    },
    {
        text: 2,
        code: 'WINE'
    },
    {
        text: 3,
        code: 'DESSERTS'
    }
];

export const serviceTypes = [
    {
        id: 0,
        code: 'PRE_FLIGHT'
    },
    {
        text: 1,
        code: 'POST_FLIGHT'
    },
    {
        text: 2,
        code: 'IN_FLIGHT'
    }
];

export const fallbackImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==';

// Booking Status
export const bookingStatus = [
    {
        id: 0,
        code: 'CREATED'
    },
    {
        text: 1,
        code: 'AWAITING_CONFIRMATION'
    },
    {
        text: 2,
        code: 'CONFIRMED'
    },
    {
        text: 3,
        code: 'CANCELLED'
    },
    {
        text: 4,
        code: 'EXECUTED'
    }
];

// aircraft category
export const aircraftCategory = {
    ALL: 'ALL',
    CLASS_AIRTAXI: 'CLASS_AIRTAXI',
    CLASS_TURBO_PROPS: 'CLASS_TURBO_PROPS',
    CLASS_VERY_LIGHT: 'CLASS_VERY_LIGHT',
    CLASS_LIGHT: 'CLASS_LIGHT',
    CLASS_MIDSIZE: 'CLASS_MIDSIZE',
    CLASS_SUPER_MIDSIZE: 'CLASS_SUPER_MIDSIZE',
    CLASS_HEAVY: 'CLASS_HEAVY',
    CLASS_LONG_RANGE_JET: 'CLASS_LONG_RANGE_JET',
    CLASS_VIP_AIRLINER: 'CLASS_VIP_AIRLINER'
};

// amenities list
export const amenitiesList = {
    EXTRA_LEG_ROOM: 'EXTRA_LEG_ROOM',
    WIFI: 'WIFI',
    BED: 'BED',
    SINK: 'SINK',
    LAVATORY: 'LAVATORY'
};

// booking category
export const bookingCategory = {
    ALL: 'ALL',
    NEW_BOOKING: 'CREATED',
    AWAITING_PAYMENT: 'AWAITING_CONFIRMATION',
    BOOKING_CONFIRMED: 'CONFIRMED',
    BOOKING_CANCELLED: 'CANCELLED'
};

export const EXCEPT_EDIT_BOOKING = ['EXECUTED', 'CANCELLED'];

export const FLIGHT_SALE_TYPE = {
    EMPTY_LEG: 'EMPTY_LEG',
    SHARED: 'SHARED',
    SCHEDULED: 'SCHEDULED'
};

export const NOTIFICATION_TYPES = {
    BOOKING: 'Booking',
    FLIGHT: 'Flight',
    INVOICE: 'Invoice',
    COMPANY: 'Company',
    QUOTE_REQUEST: 'QuoteRequest',
    REQUEST: 'Request'
};

export const BOOKING_TYPES = {
    ONEWAY: 'ONEWAY',
    RETURN: 'RETURN',
    MULTI_LEG: 'MULTI_LEG'
};

export const FLIGHT_TYPES = {
    ONEWAY: 'ONEWAY',
    RETURN: 'RETURN',
    MULTI_LEG: 'MULTI_LEG'
};

export const INVOICE_ITEMS = {
    BOOKING_FEE: 'BOOKING_FEE',
    BROKER_FEE: 'BROKER_FEE',
    SERVICES: 'SERVICES',
    FLIGHTS: 'FLIGHTS'
};

export const CREATE_QUOTATION_STEP = {
    AIRCRAFT: 'AIRCRAFT',
    SERVICES: 'SERVICES',
    INVOICE: 'INVOICE',
    SUMMARY: 'SUMMARY'
};

export const GLOBAL_STYLE_CONSTANTS = {
    padding: '20px min(40px, 4%) 40px'
};

// Image file extensions
export const IMAGE_FILE_EXTENSIONS = ".jpg, .jpeg, .jpe, .jif, .jfif, .png, .ico";